/**
 * Matching what a person typed into a search box against text on screen.
 *
 * This is user search: the query is free text and so is the haystack, so a
 * loose case-insensitive containment check is the intended behaviour rather
 * than a domain fact being recovered from a label.
 */

/** Whether every part of the haystack list contains the query, loosely. */
export function matchesQuery(
  query: string,
  ...haystacks: (string | null | undefined)[]
): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return haystacks.some((value) =>
    (value ?? "").toLowerCase().includes(needle),
  );
}

/**
 * One comparable spelling of free text a person typed, so two entries that
 * differ only in case or spacing are treated as the same criterion.
 */
export function comparableText(value: string): string {
  return value.trim().toLocaleLowerCase().replace(/\s+/g, " ");
}
